import React, { useEffect, useState, useContext } from "react";

import icon1 from "../../../asset/image/new/hla-b-58-1.svg";
import icon2 from "../../../asset/image/new/hla-b-57-1.svg";
import icon3 from "../../../asset/image/new/hla-b-15-1.svg";
import icon4 from "../../../asset/image/new/nat2-1.svg";
import icon5 from "../../../asset/image/new/hla-a31-01-01.svg";
import icon6 from "../../../asset/image/new/hla-a13-01-01.svg";
import * as publicApi from "../../../service/publicApi";
import { CurrentUserContext } from "../../../App";
import * as regex from "../../../service/regex";

function InspectionStatistics() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const [isHovered, setIsHovered] = useState({ name: null, status: false });
  const [getInspectionList, setInspectionList] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    let res = await publicApi.getInspectionStatistics();
    if (res) {
      if (res["data"]["code"] === 200) {
        setInspectionList(res["data"]["data"]);
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    }
  };

  const inspectionList = [
    {
      id: "hlab5801",
      url: `${icon1}`,
      name: "HLA-B*58:01",
      title:
        "การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Allopurinol",
      description: "สำหรับผู้ป่วยก่อนได้รับยา",
      drug: "Allopurinol",
      quantity: regex.FormatNumber(getInspectionList?.hlab5801 ?? 0),
      theme: "#86B8EE",
    },
    {
      id: "hlab5701",
      url: `${icon2}`,
      name: "HLA-B*57:01",
      title:
        "การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Abacavir",
      description: "สำหรับผู้ป่วยก่อนได้รับยา",
      drug: "Abacavir",
      quantity: regex.FormatNumber(getInspectionList?.hlab5701 ?? 0),
      theme: "#F37F25",
    },
    {
      id: "hlab1502",
      url: `${icon3}`,
      name: "HLA-B*15:02",
      title:
        "การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
      description: "สำหรับผู้ป่วยก่อนได้รับยา",
      drug: "Carbamazepine",
      quantity: regex.FormatNumber(getInspectionList?.hlab1502 ?? 0),
      theme: "#FB7982",
    },
    {
      id: "nat2_diplotype",
      url: `${icon4}`,
      name: "NAT2-diplotype",
      title:
        "การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniacid เพื่อพิจารณาให้ยาในขนาด",
      description: "สำหรับผู้ป่วยก่อนได้รับยา",
      drug: "Isoniacid",
      quantity: regex.FormatNumber(getInspectionList?.nat2_diplotype ?? 0),
      theme: "#FFD748",
    },
    {
      id: "hlaa3101",
      url: `${icon5}`,
      name: "HLA-A*31:01",
      title:
        "การตรวจ HLA-A*31:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
      description: "สำหรับผู้ป่วยก่อนได้รับยา",
      drug: "Carbamazepine",
      quantity: regex.FormatNumber(getInspectionList?.hlab1301 ?? 0),
      theme: "#9989c1",
    },
    {
      id: "hlab1301",
      url: `${icon6}`,
      name: "HLA-B*13:01",
      title:
        "การตรวจ HLA-B*13:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Dapsone",
      description: "สำหรับผู้ป่วยก่อนได้รับยา",
      drug: "Dapsone",
      quantity: regex.FormatNumber(getInspectionList?.hlaa3101 ?? 0),
      theme: "#bdd975",
    },
  ];

  const ThaiDateDisplay = () => {
    const currentDate = new Date();

    const thaiFormattedDate = new Intl.DateTimeFormat("th-TH", {
      year: "numeric",
      month: "numeric", // long
      day: "numeric",
      // weekday: 'long',
      calendar: "buddhist",
    }).format(currentDate);

    return <span>ณ วันที่ {thaiFormattedDate}</span>;
  };

  return (
    <>
      <div className="w-full flex flex-col items-center mt-2 mb-8">
        <div className="text-[22px] text-center font-bold mb-6">
          ข้อมูลสถิติการตรวจสะสม {ThaiDateDisplay()}
        </div>
        <div className="grid grid-cols-3 md:grid-cols-2 2sm:grid-cols-1 gap-6">
          {inspectionList.map((data) => {
            return (
              <div
                key={data.id}
                className="flex items-center gap-8 border border-[#E0E0E0] p-3 rounded-lg"
                style={{
                  boxShadow:
                    isHovered.name === data.name && isHovered.status
                      ? `2px 4px 5px ${data.theme}80`
                      : "none",
                }}
                onMouseEnter={() =>
                  setIsHovered({ name: data.name, status: true })
                }
                onMouseLeave={() =>
                  setIsHovered({ name: data.name, status: false })
                }
              >
                <img
                  src={data.url}
                  className="w-[100px] h-[100px]"
                  alt={`ไอคอนแสดงสถิติการตรวจ ${data.id}`}
                />
                <div className="flex flex-col justify-center text-center">
                  <span
                    className="text-[1.15rem]"
                    style={{ color: data.theme }}
                  >
                    {data.id === "nat2_diplotype" ? (
                      <span>
                        <span style={{ fontStyle: "italic" }}>NAT2</span>
                        -diplotype
                      </span>
                    ) : (
                      data.name
                    )}
                  </span>
                  <span className="text-[0.8rem]" style={{ color: data.theme }}>
                    {data.description}
                    <br />
                    {data.drug}
                  </span>
                  <span className="text-[2rem] font-bold">
                    {data.quantity ?? 0}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default InspectionStatistics;
